import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';


const server_backend = config.API_URL;

function UpdateOptionJobValue({ username, onClose, optjv_ID, getOptionValue }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [JobCategory, setJobCategory] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        optjc_id: "",
        value: "",
        comment: "",
        optjv_id: optjv_ID
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        const getOptionValue = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_value/select?id=${optjv_ID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        id: optjv_ID,
                        est_id: data.est_ID,
                        optjc_id: data.optjc_ID,
                        value: data.value,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getOptionValue();
    }, [optjv_ID, username]);

    useEffect(() => {
        const getJobCategory = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_category/list`, headers);

                if (response.data.RES_CODE === "00") {
                    setJobCategory(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getJobCategory();
    }, []);

    const handleUpdate = async (e) => {
        e.preventDefault();

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(`${server_backend}/options_job_value/update`, formData, headers);
                    setLoading(true);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        getOptionValue();
                        onClose();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Option Job Value already exists, please try another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (

        <div className="container-fluid">
            <div className="row">
                <div className="card">
                    <div className="card-header align-items-center d-flex">
                        <div className="col-md-12">
                            <div className="text-end">
                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            onClose();
                                        }
                                    }
                                    )
                                }
                                }>Discard Change</Link>
                                <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                                    {loading ? "Loading..." : "Update"}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="card-header">
                        <center>
                            <h5>Update Option Job Value</h5>
                            <h6>Current ID:</h6> <Link>{optjv_ID}</Link>
                        </center>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Material name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="matt_id" className="form-label">Option Category</label>
                                        <select
                                            className="form-select"
                                            aria-label=".form-select-sm example"
                                            name="optjc_id"
                                            value={formData.optjc_id}
                                            onChange={handleChange}
                                        ><option>Select the option</option>
                                            {JobCategory.map((OptionJ) => (
                                                <option key={OptionJ.optjc_ID} value={OptionJ.optjc_ID}>
                                                    {OptionJ.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <br />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label htmlFor="value" className="form-label">Value</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Value"
                                        name="value"
                                        value={formData.value}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="user_transaction" className="form-label">Status <span style={{ color: 'red' }}>*</span></label>
                                        <select
                                            className="form-select"
                                            aria-label=".form-select-sm example"
                                            name="est_id"
                                            value={formData.est_id}
                                            onChange={handleChange}
                                            required
                                        >
                                            {formData.est_id === 1 ? (
                                                <>
                                                    <option value="1">Activated</option>
                                                    <option value="2">Disabled</option>
                                                </>
                                            ) : (
                                                <>
                                                    <option value="2">Disabled</option>
                                                    <option value="1">Activated</option>
                                                </>
                                            )}
                                        </select>
                                    </div>
                                    <br />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="comment" className="form-label">Comment</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter comment"
                                        name="comment"
                                        value={formData.comment}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                            </div>

                            <h4 className='p-3'>Other Information</h4>
                            <div className="row">
                                <div className="col-6 mb-3">
                                    <label htmlFor="date_created" className="form-label">Date Created</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={vAdminformat.FormatDate(dateCreated)}
                                        disabled
                                    />
                                </div>
                                <div className="col-6  mb-3">
                                    <label htmlFor="user_transaction" className="form-label">User Created</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.user_transaction}
                                        disabled
                                    />
                                </div>

                                <div className="col-6  mb-3">
                                    <label htmlFor="date_modify" className="form-label">Date Modified</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={dateModify && vAdminformat.FormatDate(dateModify)}
                                        disabled
                                    />
                                </div>
                                <div className="col-6  mb-3">
                                    <label htmlFor="user_created" className="form-label">User Modified</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={userModify}
                                        disabled
                                    />
                                </div>

                                <div className="card-header align-items-center d-flex">
                                    <div className="col-md-12">
                                        <div className="text-end">
                                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                                Swal.fire({
                                                    icon: 'warning',
                                                    title: 'Alert',
                                                    text: "Are you sure you want to discard these changes?",
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Accept',
                                                    cancelButtonText: "Cancel"
                                                }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                        onClose();
                                                    }
                                                }
                                                )
                                            }
                                            }>Discard Change</Link>
                                            <button className="btn btn-primary" type="submit" disabled={loading}>
                                                {loading ? "Updating..." : "Update"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div >

    );
}

export default UpdateOptionJobValue;
